import { defineMessages } from 'react-intl';

export const scope = 'cb.components.ShareReferralCode';

export default defineMessages({
  shareThisCodeBlockHeading: {
    id: `${scope}.shareThisCode`,
    defaultMessage: 'Share your referral link and earn points',
  },
  shareCodeHelpText: {
    id: `${scope}.shareCodeHelpText`,
    defaultMessage: 'Invite your customers to My Couponbook app with your referral link',
  },
  shareLinkHelpText: {
    id: `${scope}.shareLinkHelpText`,
    defaultMessage: 'earn 500 points each year they remain join premium.',
  },
  codeWasCopiedFeedbackText: {
    id: `${scope}.codeWasCopiedFeedbackText`,
    defaultMessage: 'Code was copied to the clipboard',
  },
  shareReferralCodeAlt: {
    id: `${scope}.shareReferralCodeAlt`,
    defaultMessage: 'Share your code',
  },
});
